// Resalte compartido entre la lista y el mapa de /negocios.
// Pasar el «hover» por estado de React re-renderizaba la página entera (las ~50 tarjetas y el mapa)
// con cada tarjeta que tocaba el mouse. Acá vive fuera de React: el mapa se suscribe y pinta el pin
// con feature-state, y la lista no se entera.
let current = null;
const listeners = new Set();

export const highlightStore = {
  get: () => current,
  set(id) {
    if (id === current) return;
    current = id;
    listeners.forEach((listener) => listener(id));
  },
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }
};
